<template>
  <div class="home-page cg-page">
    <div class="login-content">
      <div class="pt20 disflex" style="justify-content: center;position: fixed;background:url(static/images/star.png) no-repeat 0 0;max-width:750px;height: 317px;background-size: cover;    align-items: flex-start;">
        <a class="logo" style="width: 150px;margin: 0 30px;" href="/"><img src="static/images/logo1.png" /></a>
      </div>
      <div class="landing-page">
        <div class="">
          <div class="home-prize" style="padding-top: 185px;">
            <div class="home1 ac">
              <img :src="isEN=='bur'?'../../static/images/login-bg4.png':'../../static/images/login-bg4.png'">
            </div>
          </div>
          <div class="">
            <div class="lg-bg2">
              <div class="ac mt30">
                <div class="drown-list drown-bg" style="">
                  <div class="input-div ">
                    <div class="span fs26 ac fw7" style="font-weight: 400;margin-bottom: 15px;">{{$t('landFont1')}}</div>
                    <div class="input-item">
<!--                      <span>09</span>-->
                      <input class="input" v-model="mobile" placeholder="">
                    </div>
                  </div>
                  <div class="disflex" style="margin-top: 50px">
                    <div class="drown-li" @click="goLogin()">
                      <div class="disflex day" >
                        <span>{{$t('Login')}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer-content ac" style="justify-content: space-evenly;">
              <div class="icon icon2" @click="getHref('faq')">
                <img src="../../static/images/menu-icon5.png" />
                <span>{{$t('FAQs')}} >></span>
              </div>
              <div class="icon icon3" @click="getHref('termsAndCondition')">
                <img src="../../static/images/menu-icon6.png" />
                <span>{{$t('TC')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import Header from '../components/headerNo'
import Dialog from '../components/dialog'
export default {
  components:{
    Header,Dialog
  },
  data() {
    return {
      type:'',
      isEN:'bur',
      mobile:'',
      code:'',
    }
  },
  created(){
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
    if (this.$route.query.msisdn){
      let that = this
      that.mobile = this.$route.query.msisdn;
    }
    if (this.$route.query.type){
      let that = this
      that.type = this.$route.query.type;
    }
    if (this.$route.query.code){
      let that = this
      that.code = this.$route.query.code;
    }
  },
  methods: {
    getHref(type){
      this.$router.push({path:type,query:{type:type}});
    },
    back(){
      this.$router.go(-1);
    },
    goLogin(){
      let that = this
      if(!this.mobile){
        that.$utils.alertText(that.$t('loginTips'),80)
      }else{
        this.checkMobile();
      }
    },
    checkMobile(){
      let that = this
      that.$parent.loadModal(true);
      let mobile = this.mobile
      let data = {
        'mobile': mobile,
      }
      //检测号码
      that.$api.post('/api/user/check_user',data,r =>{
        if(r.code==1){
            that.$parent.loadModal(false);
            localStorage.setItem('token',r.data.userinfo.token)
            localStorage.setItem('mobile',r.data.userinfo.mobile)
            // localStorage.setItem('lang','en')
            that.mobile = ''
            this.$router.push({path:'/'})
        }else if(r.code == -1){
            window.location.href = r.data;
        } else{
            that.$parent.loadModal(false);
            that.$utils.alertText(r.msg,100,2000);
        }
      })
    },
  }
}
</script>
<style scoped>
.drop-down-content{z-index:9;background:none;}
.landing-page{padding-bottom:60px;}
.cg-page{background: url(../../static/images/bg3-png.jpg) no-repeat center top #0034ae;}
.input-item{background:url(../../static/images/input-bg.png) no-repeat center center;background-size: contain;height: 102px;width: 474px;display: flex;align-items: center;}
.input-div div span{color:#0036af;}
.input-div .input{color:#0036af;}
.drown-list{width: auto;margin-top: -40px;}
.drown-bg .drown-li.active::before,.drown-bg .drown-li::before{display: none;}
.drown-list .disflex{font-size: 30px;font-weight: 700;box-shadow: none;background-color: none;text-shadow: #000000 -5px 2px;    margin-top: -12px;}
.week{background: url(../../static/images/week.png) no-repeat;width: 60%;background-size: contain;min-height: 140px;width: 401px;height: 327px;margin: 0 auto;}
.day{background: url(../../static/images/login.png) no-repeat;background-size: contain;min-height: 100px;width: 320px;}
.month{background: url(../../static/images/month.png) no-repeat;background-size: contain;min-height: 100px;width: 275px;}
.lg-bg2{background:url(../../static/images/login-img3.png) no-repeat center 70px;}



.package-modal {
  position: fixed;
  inset: 0;
  background: url(/static/images/bg3-png.jpg) no-repeat center bottom #040b35;
  color: #fff;
  z-index: 999;
  display: flex;
  flex-direction: column;
}

.modal-header {
  margin-top: 3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.5rem;
  font-size: 3.5rem;
  font-weight: 700;
  color: white;
}

.close-btn {
  background: none;
  border: none;
  font-size: 3.5rem;
  font-weight: 700;
  color: #1bf21b;
  cursor: pointer;
}

.modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
}

.section-title {
  font-size: 0.24rem;
  font-weight: 700;
  margin: 0.20rem 0;
}

.package-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  background: #1a1a1a;
  cursor: pointer;
  transition: 0.2s;
  height: 12rem;
}

.package-card:hover {
  background: #222;
}

.package-card.active {
  border: 0.03rem solid #ff6bcb;
}

.package-card {
  border: 0.03rem solid #6d6369;
}

.package-card .info {
  flex: 1;
}

.package-card .name {
  font-size: 2.5rem;
  font-weight: 600;
  color: #f8b4d9;
}

.package-card .best {
  background: #444;
  color: #f99;
  font-size: 1.5rem;
  padding: 0.03rem 0.08rem;
  border-radius: 0.08rem;
  margin-left: 0.11rem;
}

.package-card ul {
  margin: 0.07rem 0 0;
  padding: 0;
  list-style: none;
  font-size: 1.5rem;
  color: #ddd;
}

.package-card .price {
  background: #ffd84d;
  color: #111;
  font-weight: 700;
  padding: 0.08rem 0.5rem;
  border-radius: 0.5rem;
  font-size: 2rem;
  min-width: 2rem;
  text-align: center;
  margin-right: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue